import { ReactNode } from 'react';

interface Props {
  /**
   * The help message. This could be plain text, HTML, or a React node.
   */
  children: ReactNode;
}

/**
 * Simple message component that displays help messages in various forms.
 */
export const HelpMessage = ({ children }: Props) => {
  if (typeof children !== 'string') {
    return <>{children}</>;
  }

  if (!children?.length) return null;

  const isHtml = /<\/?[a-z][\s\S]*>/.test(children);
  if (!isHtml) return <>{children}</>;

  return <span dangerouslySetInnerHTML={{ __html: children }} />;
};
